export function createCircleIcon(
  color: string,
  style: 'filled' | 'dotted' | 'dashed' = 'filled',
  glow: boolean = false
): HTMLCanvasElement {

  const size = 70;
  const dpr = window.devicePixelRatio || 1;

  const canvas = document.createElement('canvas');

  // Scale for retina displays
  canvas.width = size * dpr;
  canvas.height = size * dpr;
  canvas.style.width = `${size}px`;
  canvas.style.height = `${size}px`;

  const ctx = canvas.getContext('2d');
  if (!ctx) return canvas;

  ctx.scale(dpr, dpr); // Important!

  const center = size / 2;
  const radius = 16; // Slightly smaller to avoid clipping

  // Glow
  if (glow) {
    ctx.shadowColor = color;
    ctx.shadowBlur = 12;
    ctx.shadowOffsetX = 0;
    ctx.shadowOffsetY = 0;
  }

  ctx.beginPath();
  ctx.arc(center, center, radius, 0, Math.PI * 2, false);

  if (style === 'filled') {
    ctx.fillStyle = color;
    ctx.fill();
  } else {
    ctx.strokeStyle = color;
    ctx.lineWidth = style === 'dotted' ? 2 : 2.5;
    ctx.setLineDash(
      style === 'dotted'
        ? [2, 4]
        : style === 'dashed'
        ? [6, 4]
        : []
    );
    ctx.stroke();
  }

  ctx.shadowBlur = 0;
  ctx.setLineDash([]);

  return canvas;
}
